import React, { forwardRef } from "react";
import { ArrowRight } from "@/components/icons";
import useTranslations from "@/i18n/useTranslations";

interface ShowAllButtonProps {
  totalCount: number;
  isExpanded: boolean;
  onToggle: () => void;
}

export const ShowAllButton = forwardRef<HTMLButtonElement, ShowAllButtonProps>(
  ({ totalCount, isExpanded, onToggle }, ref) => {
    const tExpand = useTranslations("ExpandableBlock");
    const t = useTranslations("GuidedPath");
    if (isExpanded) {
      return (
        <button
          ref={ref}
          onClick={onToggle}
          className="bg-white text-gray-900 w-full rounded-full transition-all py-4 px-6"
        >
          <div className="font-bold text-base flex items-center gap-2 justify-center text-center">
            {tExpand("showLess")}
          </div>
        </button>
      );
    }

    return (
      <button
        ref={ref}
        onClick={onToggle}
        className="not-prose bg-white text-gray-900 w-full rounded-full transition-all border border-putty-700 py-3 px-4"
      >
        <div className="font-bold text-base flex items-center gap-2 justify-center text-center">
          {t("showAllOptionsCount", { count: totalCount })}
          <ArrowRight />
        </div>
      </button>
    );
  },
);

ShowAllButton.displayName = "ShowAllButton";
